import { replaceRoute } from '@/router';

type ShowCreditsOfferArgs = {
  source: string;
  feature?: string;
};

export function showCreditsOffer(args: ShowCreditsOfferArgs): void {
  replaceRoute('paymentPurchaseCredits', args);
}
